import React from 'react';
import './DesktopSidebar.css'; // Подключим стили (создадим позже)

// Иконки можно будет импортировать или определить здесь, как в Navigation.js
// Пример иконок (можно скопировать из Navigation.js или использовать библиотеки иконок)
const icons = {
    home: '🏠', // Заглушки
    chain: '👥',
    profile: '👤',
    tags: '🏷️',
    invites: '➕',
    notifications: '🔔',
    activities: '🚀', 
    dependencyGraph: '🕸️'
};

const DesktopSidebar = ({ activeSection, onSectionChange }) => {

    const menuItems = [
        { id: 'home', label: 'Дашборд', icon: icons.home },
        { id: 'chain', label: 'Поиск', icon: icons.chain },
        { id: 'notifications', label: 'Сообщения', icon: icons.notifications },
        { id: 'activities', label: 'Активности', icon: icons.activities },
        { id: 'invites', label: 'Приглашения/Создать', icon: icons.invites },
        { id: 'dependencyGraph', label: 'Граф связей', icon: icons.dependencyGraph },
        { id: 'profile', label: 'Мой профиль', icon: icons.profile },
        // Добавьте другие секции при необходимости
    ];

    return (
        <div className="desktop-sidebar">
            <div className="sidebar-header">
                <h2>VINCLE</h2> 
                {/* Можно добавить логотип */}
            </div>
            <nav className="sidebar-nav">
                {menuItems.map(item => (
                    <div
                        key={item.id}
                        className={`nav-tile ${activeSection === item.id ? 'active' : ''}`}
                        onClick={() => onSectionChange(item.id)}
                    >
                        <span className="tile-icon">{item.icon}</span>
                        <span className="tile-label">{item.label}</span>
                    </div>
                ))}
            </nav>
            <div className="sidebar-footer">
                {/* Можно добавить информацию о пользователе или выход */}
                <p>© 2024 VINCLE</p>
            </div>
        </div>
    );
};

export default DesktopSidebar; 